import React, { useState, useContext, useEffect, useRef } from 'react';
import { Row, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGear } from "@fortawesome/free-solid-svg-icons";
import Page from "../pages/Page";
import PageContentWrapper from "../components/PageContentWrapper";
import Breadcrumbs from "../components/Breadcrumbs";
import { UiManagerContext } from '../../config/ui.js';
import PAGES from '../data/PagesConstants';
import Sidebar from "../components/Sidebar";
import Multiselect from 'multiselect-react-dropdown';
import { getApi } from '../api/endpoints';
import { toast } from "react-toastify";

const PermissionsConfigPage = (props) => {
  const uiManager = useContext(UiManagerContext);
  const [usersTypesApi] = getApi('usersTypes');
  const [uiActionsApi] = getApi('uiActions');
  const [crmUsersApi, { isLoading }] = getApi('crmUsers');
  const [grantPermissionsApi] = getApi('grantPermissions');
  const [userOptions, setUserOptions] = useState([]);
  const [usersTypes, setUsersTypes] = useState([]);
  const [editModePermissions, setEditModePermissions] = useState([])
  const [selectedUiAction, setSelectedUiAction] = useState(null);
  const [selectedUiActionBreadcrumb, setSelectedUiActionBreadcrumb] = useState([]);
  const [selectedUsersType, setSelectedUsersType] = useState(null);
  const [selectedCrmUser, setSelectedCrmUser] = useState(null);
  const selectUserRef = useRef();
  const selectUserRoleRef = useRef();

  const prepareBreadcrumbs = () => {
    return selectedUiActionBreadcrumb.map((item, inx) => {
      return {
        label: item[1],
        onClick: (e) => {
          if (inx !== selectedUiActionBreadcrumb.length - 1) {
            e.preventDefault();
            setSelectedUiAction(item[0]);
            setSelectedUiActionBreadcrumb(selectedUiActionBreadcrumb.filter((item, index) => item[inx] <= item[index]));
          }
        }
      }
    })
  }

  const fetchUsersTypes = async () => {
    try {
      const response = await usersTypesApi({ filters: { crm_users_types: true }}).unwrap();
      setUsersTypes(response.data.users_types);
    } catch (error) {

    }
  }

  useEffect(() => {
    fetchUsersTypes();
  }, [])

  const fetchUiActions = async (params) => {
    try {
      const response = await uiActionsApi(params).unwrap();
      setEditModePermissions(response.data.ui_actions.map((uiAction) => uiAction.action_name));
    } catch (error) {

    }
  }

  useEffect(() => {
    if (selectedUsersType) {
      fetchUiActions({ users_type_id: selectedUsersType.id });
    }
    if (selectedCrmUser) {
      fetchUiActions({ user_id: selectedCrmUser.id })
    }
  }, [selectedUsersType, selectedCrmUser])

  const onUsersTypeSelect = (selectedList, selectedItem) => {
    setSelectedUsersType(selectedItem);
    setSelectedCrmUser(null)
  }

  const onCrmUserSelect = (selectedList, selectedItem) => {
    setSelectedCrmUser(selectedItem);
    setSelectedUsersType(null);
  }

  const onUsersTypeRemove = (selectedList, removedItem) => {
    setSelectedUsersType(null);
  }

  const grantPermissions = async (params) => {
    try {
      await grantPermissionsApi(params).unwrap();
      selectUserRef.current.resetSelectedValues();
      selectUserRoleRef.current.resetSelectedValues();
      setEditModePermissions([]);
      setSelectedCrmUser(null);
      setSelectedUsersType(null);
      setSelectedUiAction(null);
      setSelectedUiActionBreadcrumb([]);
      setUserOptions([]);
      toast.success('Permissions Granted !');
    } catch (error) {
      toast.error('Something Went Wrong !');
    }
  }

  const onSaveClick = () => {
    if (selectedUsersType) {
      grantPermissions({ users_type_id: selectedUsersType.id, permitted_actions: editModePermissions })
    } else if (selectedCrmUser) {
      grantPermissions({ user_id: selectedCrmUser.id, permitted_actions: editModePermissions })
    } else {
      toast.error('Please Select User Type !');
    }
  }

  const searchCrmUsers = async (params) => {
    try {
      const response = await crmUsersApi(params).unwrap();
      setUserOptions(response.data.crm_users)
    } catch (error) {

    }
  }

  const onSearch = (value) => {
    if (value.search(/^.+\@.{3,}\..{2,}$/) !== -1 || value.search(/^\d{10}$/) !== -1) {
      searchCrmUsers({ search: value, fields: 'select_options' })
    }
  }

  return <Page
    uiPage={uiManager.getUiPage(PAGES.PermissionsConfigPage.name)}
    breadcrumbs={[{ label: "Home", url: '/dashboard' }, { label: "Menu Editor", url: '/permissions/config' }]}
    className={'permissions-config-page'}
  >
    <PageContentWrapper contentHeading={"Menu Editor"}>
      <div style={{ marginTop: '30px' }}>
        <div className="mb-2 col-md-6">
          <label htmlFor="search" className="form-label">Search CRM User</label>
          <Multiselect
            options={userOptions}
            onSearch={onSearch}
            onSelect={onCrmUserSelect}
            loading={isLoading}
            singleSelect={true}
            displayValue="name"
            showArrow={true}
            customArrow={true}
            ref={selectUserRef}
          />
        </div>
        <div className="mb-2 col-md-6">
          <label className="form-label">User Role</label>
          <Multiselect
            options={usersTypes} // Options to display in the dropdown
            onSelect={onUsersTypeSelect} // Function will trigger on select event
            onRemove={onUsersTypeRemove} // Function will trigger on remove event
            displayValue="role_name" // Property name to display in the dropdown options
            singleSelect={true}
            avoidHighlightFirstOption={true}
            customArrow={true}
            ref={selectUserRoleRef}
          />
        </div>
      </div>
      <div style={{ marginTop: '30px' }}>
        <Row>
          <Col>
            <div>
              { selectedUiActionBreadcrumb && <Sidebar
                searchQueryVisible={false}
                editMode={true}
                editModeSetSelectedUiAction={setSelectedUiAction}
                editModePermissions={editModePermissions}
                setEditModePermissions={setEditModePermissions}
                editModeSelectedUiActionBreadcrumb={selectedUiActionBreadcrumb}
                editModeSetSelectedUiActionBreadcrumb={setSelectedUiActionBreadcrumb}
              />}
            </div>
          </Col>
          <Col>
            {selectedUiActionBreadcrumb.length !== 0 && <Breadcrumbs isEditMode={true} breadcrumbs={prepareBreadcrumbs()} />}

            {Object.values(uiManager.getUiAction(selectedUiAction)?.linkedUiPage?.pageUiActions || {}).map((uiAction) => {
              return <div
                style={{
                  width: '300px',
                  border: '1px solid #aeaeae',
                  padding: '5px'
                }}
                key={uiAction.actionName}
              >
                <span>
                  <input
                    type="checkbox"
                    checked={editModePermissions.indexOf(uiAction.actionName) !== -1}
                    onChange={() => {
                      if (editModePermissions.indexOf(uiAction.actionName) === -1) {
                        setEditModePermissions([...editModePermissions, uiAction.actionName])
                      } else {
                        setEditModePermissions(editModePermissions.filter((ele) => ele !== uiAction.actionName))
                      }
                    }}
                  />
                </span>
                <span style={{ marginLeft: '5px' }}>{uiAction.getTitle()}</span>
                {uiManager.getUiAction(uiAction.actionName)?.linkedUiPage &&
                  uiManager.getUiAction(uiAction.actionName).linkedUiPage.pageUiActions &&
                  editModePermissions.indexOf(uiAction.actionName) !== -1 &&
                  <span
                    className="float-end btn btn-secondary btn-xs"
                    onClick={() => {
                      if (uiManager.getUiAction(uiAction.actionName)?.linkedUiPage && uiManager.getUiAction(uiAction.actionName).linkedUiPage.pageUiActions) {
                        if (!selectedUiActionBreadcrumb.find((ele) => uiAction.actionName === ele[0] && uiManager.getUiAction(uiAction.actionName).linkedUiPage.getTitle() === ele[1])) {
                          setSelectedUiActionBreadcrumb([...selectedUiActionBreadcrumb, [uiAction.actionName, uiManager.getUiAction(uiAction.actionName).linkedUiPage.getTitle()]])
                        }
                        setSelectedUiAction(uiAction.actionName);
                      }
                    }}
                  >
                    <FontAwesomeIcon
                      icon={faGear}
                    />
                  </span>
                }
              </div>
            })}
          </Col>
        </Row>
        <Row>
          <Col>
            <button type="button" className='btn btn-sm btn-voltup-theme' style={{ float: 'left', margin: '20px' }} onClick={onSaveClick}>Save</button>
          </Col>
        </Row>
      </div>
    </PageContentWrapper>
  </Page>
};

export default PermissionsConfigPage;

